import { useEffect } from 'react';
import { showToast } from 'hfs-common-ui';
import formatMessageWrapper from '~/utils/format-message-wrapper/format-message-wrapper';
import { useUptime } from './use-uptime';

const useUptimeDisabledWsToast = () => {
  const { isUptime } = useUptime();
  useEffect(() => {
    if (isUptime) {
      const timeout = setTimeout(() => {
        showToast({
          message: formatMessageWrapper('web.uptime.ws_disabled.toast.message'),
          title: formatMessageWrapper('web.uptime.ws_disabled.toast.title'),
          icon: 'notification.info_outlined',
          iconColor: 'yellow500',
          autoClose: false,
          position: 'top-right',
        });
      }, 60000);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [isUptime]);
};

export { useUptimeDisabledWsToast };
